// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider___QwGU"};